import { api } from "@/services/api";
import { FormControl, FormLabel } from "@chakra-ui/react";
import { useQuery } from "@tanstack/react-query";
import React, { useEffect } from "react";
import Select from "react-select";
import { AddButton } from "./AddButton";
import { AxiosResponse } from "axios";
import { FieldError as Error } from "react-hook-form";
import { FieldError } from "@/components/FieldError";
import { watch } from "fs";

export interface TipoDepositoResource {
  id: string;
  nome: string;
}

interface Props {
  isInvalid: boolean;
  error?: Error;
  value: string;
  watch?: any;
  required?: boolean;
  onChange: (value: string) => void;
  labelOf?: boolean;
}

export interface OptionType {
  label: string;
  value: string;
}

export function FieldTipoDeposito({
  isInvalid,
  error,
  value: _value,
  onChange,
  required = false,
  labelOf,
  ...rest
}: Props) {
  const { data: options, isLoading } = useQuery({
    queryKey: ["tipo/deposito"],
    queryFn: () => api.get("/tipo/deposito"),
    select: (
      response: AxiosResponse<Array<TipoDepositoResource>>
    ): OptionType[] =>
      response.data.map(
        ({
          id,
          nome,
        }: {
          id: string;
          nome: string;
        }) => ({
          value: id,
          label: nome,
        })
      ),
  });

  const value: OptionType = React.useMemo(() => {
    const selected = options?.find((option) => option.value === _value);
    if (!options || !selected) {
      return { value: _value, label: "" };
    }
    return (selected || {}) as unknown as OptionType;
  }, [options, _value]);


  return (
    <FormControl isInvalid={isInvalid} mb="0.40rem">
      {!labelOf &&(
          <FormLabel fontSize={'sm'}>
            { required ? '*' : false}
            Tipo de Depósito
            <AddButton />
          </FormLabel>
        )}

      <Select
        {...rest}
        isLoading={isLoading}
        isClearable={true}
        isSearchable={true}
        options={options}
        value={value}
        placeholder="Selecione"
        onChange={(newValue) => onChange(newValue?.value || "")}
      />

      <FieldError error={error} />
    </FormControl>
  );
}
